import { Injectable } from '@angular/core';
import { BaseGemviewService } from '../../shared/base-service/base-gemview.service';
import { GemviewMessage, GemviewMessageType } from '../../shared/models/gemview.model';

/**
 * Service used to interact with the Gemview SDK and Topaz tablet.
 *
 * This is mainly achieved by setting custom DOM elements, attributes, and events which are
 * handled by the SigPlusExtLite browser extension.
 *
 * Topaz SigPlusExtLite SDK Integration Guide - see: https://www.topazsystems.com/software/SigPlusExtLite.pdf
 */
@Injectable()
export class DriverGemviewService extends BaseGemviewService {
    /**
     * Opens the signature capture window on the tablet.
     */
    public openSignatureWindow = (): void => {
        this.openWindow('/driver/signature-capture');
    };

    /**
     * Opens the questions capture window on the tablet.
     */
    public openQuestionsWindow = (businessTransactionNumber: number): void => {
        this.openWindow(`/driver/questions-capture/${businessTransactionNumber}`);
    };

    /**
     * Sends a message with the questions capture response.
     *
     * @param response - The response to send.
     */
    public sendQuestionsCaptureMessage = <T>(response: T): void => {
        this.gemviewMessagingService.send(response, GemviewMessageType.QuestionsCapture);
    };

    /**
     * Sends a message with the signature capture response.
     *
     * @param response - The response to send.
     */
    public sendSignatureCaptureMessage = <T>(response: T): void => {
        this.gemviewMessagingService.send(response, GemviewMessageType.SignatureCapture);
    };
}
